import moment from 'moment';

const dateToTime = (timestamp) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  const messageDate = moment(date);
  return messageDate.calendar(null, {
    lastDay: 'HH:mm',
    sameDay: 'HH:mm',
    lastWeek: 'HH:mm',
    sameElse: 'HH:mm',
  });
};

export default dateToTime;
